module.exports = __webpack_public_path__ + "img/ship-1.61169330.jpg";